import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField  from "../../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  });

const SkillEditWorkplace = ({onFormChange, safety, safetyFirst}) => {
    const classes = useStyles();

    const initialData = { safety: safety || '', safetyFirst: safetyFirst || '' };
    const [data, setData] = React.useState(initialData);

    const onChange = (field, value) => {
      const newState = {
        ...data,
        [field]: value
      };

      setData(newState);
      onFormChange(newState);
    };

  return (
      <div className={classes.root}>
        <Typography className={classes.heading}>Требования к организации рабочего места и технике безопасности</Typography>
        <TextField
          multiline
          value={data.safety}
          label="Общие требования безопасности"
          onChange={(e) =>  onChange("safety", e.target.value)}
        />
        <TextField
          multiline
          label="Требования безопасности перед началом работы"
          value={data.safetyFirst}
          onChange={(e) =>  onChange("safetyFirst", e.target.value)}
        />
      </div>
  );
};

export default SkillEditWorkplace;
